import React from "react"

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner } from "sonner"

import type { ToasterProps } from "sonner"

// API: https://sonner.emilkowal.ski/getting-started

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      richColors 
      className="toaster group font-default"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        duration: 2000,
        classNames: {
          toast:"w-fit group toast group-[.toaster]:border-border group-[.toaster]:shadow-lg p-4 gap-4 border",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:font-medium rounded px-3 py-1",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:font-medium rounded px-3 py-1",
          closeButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:font-medium rounded-full border",
          success: "border-green-200!",
          error: "border-red-200!",
          warning: "border-yellow-200!",
          info: "border-blue-200!",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
